.wrapper {
  flex-direction: column;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  padding: calc(2 * var(--spacer)) calc(3 * var(--spacer)) var(--spacer) calc(2 * var(--spacer));
  flex-wrap: wrap;

  .smartviews-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: calc(var(--spacer) * 2);

    .title {
      flex: 0.8;
      color: var(--main-titles-inputs-600);
      line-height: calc(var(--spacer) * 3);
    }
  }

  .smartviews-actions {
    display: flex;
    align-items: center;

    gz-button {
      display: inline-flex;
      padding: 0 var(--spacer);
      border-right: 1px solid var(--chart-100-pressed);
    }

    gz-icon-button {
      display: inline-flex;
      padding: 0 var(--spacer);
    }
  }

  .smartviews-filters {
    display: flex;
    justify-content: flex-end;
    padding-top: var(--spacer);
    gap: calc(var(--spacer) * 2);
  }
}

gz-search-query {
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: var(--chart-101-pressed-dividers);
  border-bottom-width: 0;

  &.py-1 {
    padding-bottom: 0;
  }
}

#countdown-container {
  font-size: var(--body-size);
  padding-left: calc(var(--spacer) * 2);
  height: calc(var(--spacer) * 3);
  font-style: italic;
  color: var(--body-text-arrows-400);

  &.milestone-0 {
    color: var(--orange-alert-chart-100);
  }

  &.milestone-1 {
    color: var(--red-alert-chart-700-critical);
  }

  gz-text {
    font-size: var(--body-size);
    float: left;
    width: auto;
    vertical-align: middle;
    line-height: calc(var(--spacer) * 3);
  }

  gz-count-down {
    vertical-align: middle;
    line-height: calc(var(--spacer) * 3);
  }
}

#countdown-finished-text {
  color: var(--red-alert-chart-700-critical);
  padding-left: calc(var(--spacer) * 2);
  font-size: var(--body-size);
  font-style: italic;
}

gz-live-search-metadata {
  z-index: 100;
  position: relative;
  bottom: 0;
  width: 100%;
  background: var(--background-transparent);
  font-family: var(--font-family-secondary);
}
